/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Adjust_NewInputs */

const vi_customer_debt_adjust_new = /** @type {(inputs: Customer_Debt_Adjust_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dư mới`)
};

/**

* @param {Customer_Debt_Adjust_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_adjust_new = /** @type {((inputs?: Customer_Debt_Adjust_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Adjust_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_adjust_new(inputs)
});